<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['add_marks_entry']">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="my-2" v-if="exammarks.length <= 0">
              <div class="row">
                <b-form-group class="col-md-2" label="Class">
                  <v-select
                    :options="schoolclasses"
                    @input="FilterSubjects"
                    placeholder="Select Class"
                    v-model="schoolclass"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2" label="Subjects">
                  <v-select
                    :options="schoolsubjects"
                    placeholder="Select Subject"
                    v-model="schoolsubject"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2" label="Year"
                  >{{ users.username }}
                  <v-select
                    :options="years"
                    placeholder="Select Year"
                    v-model="year"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2" label="Term">
                  <v-select
                    :options="schoolterms"
                    placeholder="Select Term"
                    @input="FilterCompetencies"
                    v-model="schoolterm"
                    label="name"
                  ></v-select>
                </b-form-group>
                <div class="col-md-1 mt-md-4 mt-2 p-0">
                  <b-button
                    variant="primary"
                    class="w-100"
                    @click="FilterData()"
                    ><i class="mdi mdi-account-search"></i> Fetch</b-button
                  >
                </div>
              </div>
            </div>
            <div v-else>
              <div class="text-center">
                <span class="h4"
                  >{{ schoolclass.name }}, {{ schoolsubject.name }} :
                  {{ schoolterm.name }} - {{ year }}</span
                >
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Selected Yet</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(student_photo)="data">
                    <img
                      :src="getFiles(data.item.student.student_photo)"
                      height="50"
                    />
                  </template>
                  <template #cell(student)="data">
                    {{ data.item.student.first_name }}
                    {{ data.item.student.last_name }} -
                    <b>{{ data.item.student.student_id }}</b>
                  </template>
                  <template #cell(gender)="data">
                    {{ data.item.student.gender }}
                  </template>
                  <template #cell(mark)="data">
                    <div class="d-flex align-items-center" style="gap:10px;">
                      <input
                        min="1"
                        max="100"
                        :value="data.item.mark"
                        @blur="changeMark($event.target.value, data.item.id)"
                        type="number"
                        class="form-control w-50"
                      />
                      <span v-if="markStatus[data.item.id] === true">
                        <b> <i class="mdi mdi-check text-success  "></i></b>
                      </span>
                      <span v-else-if="markStatus[data.item.id] === false">
                        <i class="mdi mdi-close text-primary"></i
                      ></span>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
//   import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schooltermComputed,
  schooltermMethods,
  userComputed,
  userMethods,
  staffmemberComputed,
  staffmemberMethods,
} from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "EOT Marks",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "EOT Marks",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "EOT Marks", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 50,
      Options: [50, 10, 150, 200, 300],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "student_photo", label: "Photo", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student", label: "Name", visible: true },
        { key: "mark", label: "Mark", visible: true },
      ],
      id: "",
      user: "",
      schoolsubjects: [],
      schoolsubject: "",
      schoolterm: "",
      schoolclasses: [],
      schoolclass: "",
      exam: "",
      exams: [],
      subjectcompetencies: [],
      subjectcompetency: "",
      year: new Date().getFullYear(),
      exammarks: [],
      markStatus: {},
    };
  },
  computed: {
    ...schooltermComputed,
    ...userComputed,
    ...staffmemberComputed,
    List() {
      return this.exammarks.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.exammarks.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.exammarks.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolTerms();
    this.FilterClass();
    this.TotalRows = this.exammarks.length;
    this.isBusy = false;
    // this.schoolterm = this.schoolterms.find(option => option.active == 1);
  },
  methods: {
    ...schooltermMethods,
    ...userMethods,
    ...staffmemberMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async FilterClass() {
      let url = `/findschoolclass/${this.userData.user_id}`;
      await axios.get(url).then((response) => {
        this.schoolclasses = response.data.classes;
      });
    },
    async FilterSubjects() {
      let url = `/findschoolsubject/${this.userData.user_id},${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.schoolsubjects = response.data.subjects;
      });
    },
    async FilterCompetencies() {
      let url = `/findsubjectcompetencies/${this.schoolclass.id},${this.schoolsubject.id},${this.schoolterm.id},${this.year}`;
      await axios.get(url).then((response) => {
        this.subjectcompetencies = response.data.subjectcompetencies;
      });
    },
    async FilterExams() {
      let url = `/findschoolexam/${this.schoolterm.id},${this.year},${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.exams = response.data.exams;
      });
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },
    FilterData() {
      let formData = new FormData();
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("user", this.userData.user_id);
      formData.append("exam", this.exam.id);
      formData.append("subject", this.schoolsubject.id);
      formData.append("competency", this.subjectcompetency.id);
      let url = "/addeotexammarks";
      axios.post(url, formData).then((response) => {
        this.exammarks = response.data.marks;
      });
    },
    async changeMark(mark, id) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("mark", mark);
      let url = "/updateeotexammarks";
      await axios
        .post(url, formData)
        .then((response) => {
          if (response.status == 200) {
            this.id = id;
            this.$set(this.markStatus, id, true);
          }
        })
        .catch((error) => {
          this.$set(this.markStatus, id, false);
          this.$swal({
            title: "Error",
            text: error.response.data.error + ". Please try again.",
            icon: "error",
          });
        });
    },
  },
};
</script>
